import { ReportFieldType } from './report.field.type'

/**
 * Enum for all the operators that can be used in a report query
 */
export enum Operator {

    Today = 'Today',
    Yesterday = 'Yesterday',
    Tomorrow = 'Tomorrow',

    On = 'On',
    OnOrBefore = 'On Or Before',
    OnOrAfter = 'On Or After',

    OnOrBeforeToday = 'On Or Before Today',
    OnOrBeforeYesterday = 'On Or Before Yesterday',
    OnOrBeforeTomorrow = 'On Or Before Tomorrow',
    OnOrBeforeXDaysAgo = 'On Or Before X days ago',
    OnOrBeforeXDaysFromNow = 'On Or Before X days from now',

    OnOrAfterToday = 'On Or After Today',
    OnOrAfterYesterday = 'On Or After Yesterday',
    OnOrAfterTomorrow = 'On Or After Tomorrow',
    OnOrAfterXDaysAgo = 'On Or After X days ago',
    OnOrAfterXDaysFromNow = 'On Or After X days from now',

    LastXDays = 'Last X Days',
    NextXDays = 'Next X Days',

    ThisWeek = 'This Week',
    ThisMonth = 'This Month',
    ThisYear = 'This Year',

    LastXWeeks = 'Last X Weeks',
    LastXMonths = 'Last X Months',
    LastXYears = 'Last X Year',

    NextXWeeks = 'Next X Weeks',
    NextXMonths = 'Next X Months',
    NextXYears = 'Next X Years',

    ThisQuarter = 'This Quarter',
    LastQuarter = 'Last Quarter',
    NextQuarter = 'Next Quarter',
    LastXQuarters = 'Last X Quarters',
    NextXQuarters = 'Next X Quarters',

    MonthToDate = 'Month To Date',
    YearToDate = 'Year To Date',
    QuarterToDate = 'Quarter To Date',

    ThisFiscalYear = 'This Fiscal Year',
    LastFiscalYear = 'Last Fiscal Year',
    NextFiscalYear = 'Next Fiscal Year',

    LastXFiscalYears = 'Last X Fiscal Years',
    NextXFiscalYears = 'Next X Fiscal Years',
    FiscalYearToDate = 'Fiscal Year To Date',

    ThisFiscalQuarter = 'This Fiscal Quarter',
    LastFiscalQuarter = 'Last Fiscal Quarter',
    NextFiscalQuarter = 'Next Fiscal Quarter',

    LastXFiscalQuarters = 'Last X Fiscal Quarters',
    NextXFiscalQuarters = 'Next X Fiscal Quarters',
    FiscalQuarterToDate = 'Fiscal Quarter To Date',


    ContainsData = 'Contains Data',
    DoesNotContainData = 'Does Not Contain Data',

    Equal = '=',
    NotEqual = '!=',
    Greater = '>',
    Less = '<',
    GreaterOrEqual = '>=',
    LessOrEqual = '<=',

    In = 'In',
    NotIn = 'Not In',

    Contains = 'Contains',
    DoesNotContain = 'Does Not Contain',

    CurrentUser = 'Current User'
}


export class QueryOperators {
    static readonly DateOperators = [
        Operator.Today,
        Operator.Yesterday,
        Operator.Tomorrow,
        Operator.On,
        Operator.OnOrBefore,
        Operator.OnOrAfter,

        Operator.OnOrBeforeToday,
        Operator.OnOrBeforeYesterday,
        Operator.OnOrBeforeTomorrow,
        Operator.OnOrBeforeXDaysAgo,
        Operator.OnOrBeforeXDaysFromNow,

        Operator.OnOrAfterToday,
        Operator.OnOrAfterYesterday,
        Operator.OnOrAfterTomorrow,
        Operator.OnOrAfterXDaysAgo,
        Operator.OnOrAfterXDaysFromNow,

        Operator.LastXDays,
        Operator.NextXDays,
        Operator.ThisWeek,
        Operator.LastXWeeks,
        Operator.NextXWeeks,
        Operator.ThisMonth,
        Operator.LastXMonths,
        Operator.NextXMonths,
        Operator.MonthToDate,

        Operator.ThisQuarter,
        Operator.LastQuarter,
        Operator.NextQuarter,
        Operator.LastXQuarters,
        Operator.NextXQuarters,
        Operator.QuarterToDate,

        Operator.ThisYear,
        Operator.LastXYears,
        Operator.NextXYears,
        Operator.YearToDate,

        Operator.ThisFiscalYear,
        Operator.LastFiscalYear,
        Operator.NextFiscalYear,
        Operator.LastXFiscalYears,
        Operator.NextXFiscalYears,
        Operator.FiscalYearToDate,

        Operator.ThisFiscalQuarter,
        Operator.LastFiscalQuarter,
        Operator.NextFiscalQuarter,
        Operator.LastXFiscalQuarters,
        Operator.NextXFiscalQuarters,
        Operator.FiscalQuarterToDate,

        Operator.ContainsData,
        Operator.DoesNotContainData
    ]

    static readonly NumberOperators = [
        Operator.Equal,
        Operator.NotEqual,
        Operator.Greater,
        Operator.Less,
        Operator.GreaterOrEqual,
        Operator.LessOrEqual,
        Operator.ContainsData,
        Operator.DoesNotContainData
    ]

    static readonly LookupOperators = [
        Operator.In,
        Operator.NotIn,
        Operator.ContainsData,
        Operator.DoesNotContainData
    ]
    static readonly OwnerOperators = [
        Operator.In,
        Operator.NotIn,
        Operator.ContainsData,
        Operator.DoesNotContainData,
        Operator.CurrentUser
    ]


    static readonly StringOperators = [
        Operator.Equal,
        Operator.NotEqual,
        Operator.Contains,
        Operator.DoesNotContain,
        Operator.ContainsData,
        Operator.DoesNotContainData
    ]

    static readonly BooleanOperators = [
        Operator.Equal,
        Operator.NotEqual,
        Operator.ContainsData,
        Operator.DoesNotContainData
    ]

    static getOperators(fieldType: ReportFieldType): Operator[] {
        switch (fieldType) {
            case ReportFieldType.Date:
                return QueryOperators.DateOperators;

            case ReportFieldType.Number:
            case ReportFieldType.Currency:
            case ReportFieldType.Decimal:
                return QueryOperators.NumberOperators;

            case ReportFieldType.String:
            case ReportFieldType.Link:
            case ReportFieldType.RichText:
                return QueryOperators.StringOperators;
            case ReportFieldType.WOResource:
            case ReportFieldType.FieldSupervisor:
            case ReportFieldType.Owner: {
                return QueryOperators.OwnerOperators;
            }
            case ReportFieldType.Boolean: {
                return QueryOperators.BooleanOperators;
            }

            default: {
                return QueryOperators.LookupOperators;
            }

        }
    }
}
